import { useFormContext, TextFieldElement } from 'react-hook-form-mui';
import { makeStyles } from 'tss-react/mui';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import WarningRedIcon from 'src/assets/images/icons/warning-2-red.svg';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .MuiFormLabel-root': {
    fontSize: '16px',

    [theme.breakpoints.down(1520)]: {
      fontSize: '14px',
    },
  },
  '& .MuiInputBase-input ': {
    fontSize: '16px',

    [theme.breakpoints.down(1520)]: {
      fontSize: '14px',
    },
  },
}));

const useStyles = makeStyles()(() => ({
  errorField: {
    '& .MuiInputBase-root': {
      borderRadius: '8px',
      backgroundColor: '#F5F6FA',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E72547 !important',
      borderWidth: '1px',
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E72547 !important',
    },
  },
  validField: {
    '& .MuiInputBase-root': {
      borderRadius: '8px',
      backgroundColor: '#F5F6FA',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#BFBFBF',
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#00992B !important',
    },
  },
  errorMessage: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#E72547',
    fontSize: '12px',
    marginTop: '8px',
  },
}));

interface RejectionReasonFieldProps {
  name?: string;
  placeholder?: string;
}

export const RejectionReasonField = ({ name = 'reason', placeholder = 'Input Reason' }: RejectionReasonFieldProps) => {
  const { classes } = useStyles();
  const {
    formState: { errors },
    watch,
  } = useFormContext();

  const reasonValue = watch(name);
  // Show error if field is empty (required field should show error immediately)
  // or if there are validation errors
  const hasError = !reasonValue || errors[name];

  const handleTrimOnBlur = (event: any) => {
    const value = event.target.value?.trim();
    if (value !== event.target.value) {
      event.target.value = value;
    }
  };

  return (
    <div className='mt-12'>
      <StyledBox>
        <TextFieldElement
          name={name}
          className={hasError ? classes.errorField : classes.validField}
          placeholder={placeholder}
          fullWidth
          multiline
          rows={6}
          size='small'
          label={placeholder}
          required
          validation={{ required: 'You need to fill this field' }}
          onBlurCapture={handleTrimOnBlur}
        />
      </StyledBox>
      {hasError && (
        <div className={classes.errorMessage}>
          <img src={WarningRedIcon} alt='warning' width={18} height={18} />
          <span>You need to fill this field</span>
        </div>
      )}
    </div>
  );
};
